// import defaultAvatar from "assets/img/avatar_MLB.png";
import React from "react";
import styled from "@emotion/styled";
import {getLeaderboardUserByUserId} from "modules/selectors";
import {css} from "@mui/material";

export const Row = styled.div<{isMobile: boolean}>`
	display: flex;
	gap: 10px;
	padding: 0 20px;
	height: 52px;
	background: linear-gradient(90deg, #232323 0%, #151515 100%);
	border-radius: 8px;
	align-items: center;
	margin-bottom: 8px;
	bottom: 0;
	svg {
		color: #fff;
	}

	${(props) =>
		props.isMobile &&
		css`
			border-radius: 0;
			margin-bottom: 0;
		`}
`;

// const Avatar = styled.div<{levelColor: string | null}>`
// 	position: relative;
// 	display: flex;
// 	& > img {
// 		width: 38px;
// 		height: 38px;
// 		border-radius: 10px;
// 		border: 2px solid ${(props) => props.levelColor || "#ffffff"};
// 	}
// `;

const Cell = styled.div`
	font-weight: 400;
	font-size: 14px;
`;

const Rank = styled(Cell)`
	min-width: 40px;
`;

const DisplayName = styled(Cell)`
	margin-right: auto;

	p {
		font-weight: 400;
		font-size: 16px;
		&:first-of-type {
			font-weight: 700;
			font-size: 20px;
		}
	}
`;

interface IProps {
	user: ReturnType<ReturnType<typeof getLeaderboardUserByUserId>>;
	userId: number;
	isMobile: boolean;
}

const UserInfoRow: React.FC<IProps> = ({user, userId, isMobile}) => {
	if (!user) {
		return null;
	}

	return (
		<Row isMobile={isMobile} aria-label={`${user.username} details`}>
			<Rank>
				{/*<Avatar levelColor={user.levelColor}>*/}
				{/*	<img src={user.avatar || defaultAvatar} alt={`${user.username}'s avatar`} />*/}
				{/*</Avatar>*/}
			</Rank>
			<DisplayName>
				<p>{user.username}</p>
				{/*<p>{user.levelName}</p>*/}
			</DisplayName>
		</Row>
	);
};

export default UserInfoRow;
